import { useMemo } from 'react';
import { useAuthStore } from '@app/store/auth.store';
import {
  can,
  canAgent,
  canAll,
  canAny,
  canAccessNav,
  canActAsTenant,
  isSuperAdmin,
  shouldShowTenantSwitcher,
  type NavKey,
} from '../roles';

/** Convenience hook bound to the current auth session. */
export function usePermissions() {
  const user = useAuthStore((s) => s.user);

  return useMemo(
    () => ({
      user,
      can: (permission: string) => can(user, permission),
      canAny: (permissions: string[]) => canAny(user, permissions),
      canAll: (permissions: string[]) => canAll(user, permissions),
      canAgent: (agentId: string, permission: string) =>
        canAgent(user, agentId, permission),
      canAccessNav: (key: NavKey) => canAccessNav(user, key),
      isSuperAdmin: isSuperAdmin(user),
      canActAsTenant: canActAsTenant(user),
      showTenantSwitcher: shouldShowTenantSwitcher(user),
    }),
    [user],
  );
}
